import {
  Autocomplete as MuiAutocomplete,
  autocompleteClasses,
  AutocompleteProps as MuiAutocompleteProps,
  Popper,
} from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledAutocomplete = styled(MuiAutocomplete)<
  MuiAutocompleteProps<any, boolean, boolean, boolean>
>(({ theme: { palette, spacing, colors } }) => ({
  /** Container (popupIcon & clearIcon) */
  '&.MuiAutocomplete-hasPopupIcon .MuiOutlinedInput-root': {
    padding: spacing(1.6, 3.8, 1.6, 1.6),

    /** Input */
    '&.MuiInputBase-sizeSmall': {
      minHeight: spacing(4),
      padding: spacing(0.8, 3.8, 0.8, 1.6),
    },
  },

  '&.MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon .MuiOutlinedInput-root':
    {
      paddingRight: spacing(7.6),
    },

  /** Label (primary select) */
  '& .selectLabel': {
    left: spacing(0.2),
    color: colors.inputText,

    '&.Mui-disabled': {
      color: palette.action.disabled,
    },
  },

  /** Fieldset (select) */
  '& .selectFieldset .MuiOutlinedInput-notchedOutline': {
    borderColor: colors.containerState,
  },

  /** Container */
  '&.MuiAutocomplete-root .MuiOutlinedInput-root': {
    alignItems: 'flex-end',

    '& .MuiAutocomplete-input': {
      padding: 0,
      cursor: 'inherit',
    },

    /** Icon Button (disabled) */
    '&.Mui-disabled .MuiIconButton-root': {
      color: palette.action.disabled,
    },

    /** endAdornment */
    '& .MuiAutocomplete-endAdornment': {
      right: spacing(1),
    },

    /** Popup Indicator Icon */
    '& .MuiAutocomplete-popupIndicator': {
      margin: '0',
      color: colors.inputText,
    },

    /** Clear Indicator Icon */
    '& .MuiAutocomplete-clearIndicator': {
      margin: spacing(0, 0.8, 0, 0),
      padding: spacing(0.2),
      color: colors.inputText,
    },

    /** Multiple selected options tags */
    '& .MuiAutocomplete-tag': {
      margin: spacing(0, 0.4, 0, 0),
      lineHeight: spacing(2.3),
    },
  },
}));

export const StyledPopper = styled(Popper)(({ theme: { palette } }) => ({
  [`& .${autocompleteClasses.listbox}`]: {
    boxSizing: 'border-box',
    backgroundColor: palette.background.default,

    '& ul': {
      padding: 0,
      margin: 0,
    },
  },
}));

export default StyledAutocomplete;
